export const LOADING_TAX = "LOADING_TAX";
export const GET_TAX_LIST = "GET_TAX_LIST";
export const GET_TAXBYID = "GET_TAXBYID";
export const REMOVE_TAX = "REMOVE_TAX";
export const ADD_TAX = "ADD_TAX";
export const UPDATE_TAX = "UPDATE_TAX";
